export default {
      id: "CHF-usage",
      viewBox: "0 0 12.6 16.4",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#CHF",
      toString: function () {
        return this.url;
      }
    }